"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrappedPropertyNumber = void 0;
const functions_1 = require("./functions");
const WrappedPropertyBase_1 = require("./WrappedPropertyBase");
const WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
const getRuleMessage_1 = require("../JSchema/getRuleMessage");
const fmoney_1 = require("../methods/fmoney");
const fnumber_1 = require("../methods/fnumber");
const lang_1 = require("../methods/lang");
const mround_1 = require("../methods/mround");
/**
 * obiekt reprezentujący wartośc liczbową
 *
 * @export
 * @class WrappedPropertyNumber
 * @extends {WrappedPropertyBase<INumberInternal>}
 * @implements {IWrappedProperty}
 */
class WrappedPropertyNumber extends WrappedPropertyBase_1.WrappedPropertyBase {
    constructor(props) {
        super(props);
        (0, functions_1.wrapSchemaProps)(this, this._internal, 'number', [
            'minimum',
            'maximum',
            'exclusiveMaximum',
            'exclusiveMinimum',
            'precision'
        ]);
        if (this.$schema.warnings) {
            (0, functions_1.wrapWarningProps)(this, this._internal, 'number', ['minimum', 'maximum', 'exclusiveMaximum', 'exclusiveMinimum']);
        }
        this._internal.typeok = true;
        // initVue(this, this._internal);
    }
    /**
     * sprawdza pole pod kątem błedów
     *
     * @param {*} [value] wartość
     * @param {boolean} [skipDirty] czy ma nie zaznaczać pola jako dirty
     * @returns {(string | null)} wynik
     * @memberof WrappedPropertyNumber
     */
    $validate(value, skipDirty) {
        if (this.$disabled) {
            return null;
        }
        if (value === undefined) {
            value = this.$model;
        }
        // console.time('(number)$validate');
        if (!skipDirty) {
            this.$dirty = true;
        }
        if (value === null) {
            // console.timeEnd('(number)$validate');
            if (!this._internal.typeok) {
                const message = (0, getRuleMessage_1.getRuleMessage)(this._internal, 'type', value, this.$schema);
                this.$validateResult = {
                    validation: 'type',
                    message,
                    expected: this._internal.schema.type,
                    stringValue: this.$stringValue
                };
                return message;
            }
            if (this.$schema.fieldRequired) {
                const message = (0, getRuleMessage_1.getRuleMessage)(this._internal, 'required', value, this.$schema);
                this.$validateResult = {
                    validation: 'required',
                    message,
                    expected: true
                };
                return message;
            }
            return null;
        }
        if (this.$schema.enum) {
            if (this.$schema.enum.indexOf(value) === -1) {
                const message = (0, getRuleMessage_1.getRuleMessage)(this._internal, 'enum', value, this.$schema);
                this.$validateResult = {
                    validation: 'enum',
                    message,
                    expected: this.$schema.enum
                };
                return message;
            }
        }
        const ivalue = +value;
        // console.timeEnd('(number)$validate');
        return super.$validate(ivalue);
    }
    /**
     * sprawdza pole pod kątem ostrzeżeń
     *
     * @param {*} [value] wartośc pola
     * @param {boolean} [skipDirty] czy nie zaznaczać $dirty
     * @param {string[]} [checkResult]
     * @returns {string[]} lista ostrzeżeń lub pusta tablica
     * @memberof WrappedPropertyNumber
     */
    $check(value, skipDirty, checkResult) {
        if (this.$schema.warnings && !this.$disabled) {
            this.$checkResult = [];
            if (value === undefined) {
                value = this.$model;
            }
            // console.time('(number)$validate');
            if (!skipDirty) {
                this.$dirty = true;
            }
            checkResult = checkResult || [];
            if (value === null) {
                // console.timeEnd('(number)$validate');
                if (this.$schema.warnings.fieldRequired) {
                    const message = (0, getRuleMessage_1.getWarningMessage)(this._internal, 'required', value, this.$schema);
                    this.$checkResult.push({
                        validation: 'required',
                        message,
                        expected: true
                    });
                    checkResult.push(message);
                }
                if (this.$schema.warnings.enum) {
                    if (this.$schema.warnings.enum.indexOf(value) === -1) {
                        const message = (0, getRuleMessage_1.getWarningMessage)(this._internal, 'enum', value, this.$schema);
                        this.$checkResult.push({
                            validation: 'enum',
                            message,
                            expected: this.$schema.warnings.enum
                        });
                        checkResult.push(message);
                    }
                }
                return checkResult;
            }
            const ivalue = +value;
            // console.timeEnd('(number)$validate');
            return super.$check(ivalue, skipDirty, checkResult);
        }
        return (this.$checkResult = []);
    }
    /**
     * pobranie wartości tekstowej pola
     *
     * @readonly
     * @type {(string | null)}
     * @memberof WrappedPropertyNumber
     */
    get $stringValue() {
        return this.$getUserData('$stringValue', null);
    }
    /**
     * pobranie wartości z modelu
     *
     * @protected
     * @returns {*}
     * @memberof WrappedPropertyNumber
     */
    getValue(ivalue) {
        var _a, _b;
        if (ivalue === undefined)
            ivalue = this.$model;
        // var lang = this._options._lang ? th ?? this._options.schemaMethods.lang;
        const lang = (_b = (_a = this._options._lang) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : lang_1.defaultLang.current;
        // let ivalue = obj.$model;
        /*
        if (this.$dirty) {
          this.$validate(ivalue);
        }
        */
        const stringValue = this.$getUserData('$stringValue', null);
        // console.log('getStringValue', stringValue);
        if (this._options.lazyNumbers && this.$hasFocus) {
            // const lazyValue = this.$getUserData('lazyValue', undefined);
            if (this.lazyValue != undefined) {
                // console.log('lazyValue', this.lazyValue);
                return this.lazyValue;
            }
        }
        if (ivalue === null) {
            // const svalue = this._internal.vm.stringValue;
            // if (svalue !== undefined && svalue !== null) {
            if (stringValue !== null) {
                // console.log('get stringValue if null', stringValue);
                return stringValue;
            }
            else {
                return '';
            }
        }
        if (isNaN(+ivalue)) {
            ivalue = 0;
        }
        // const err = validate(obj, ivalue);
        // if (obj.$path === 'LiczbaOdbiorcowZadania') {
        //  console.log('validate ', JSON.stringify(ivalue), JSON.stringify(err));
        // }
        // vm.error = err ? getRuleMessage(schema, err, ivalue, $schema) : null;
        // let svalue = (""+self.mround(ivalue)).replace(".",",");
        let svalue = '';
        switch (this.$schema.type) {
            case 'number':
                if (this.$schema.precision === undefined) {
                    svalue = (0, fnumber_1.fnumber)(ivalue, 8, lang);
                }
                else {
                    svalue = (0, fnumber_1.fnumber)(ivalue, this.$schema.precision, lang);
                }
                break;
            case 'money':
                if (this.$schema.precision === undefined) {
                    svalue = (0, fmoney_1.fmoney)(ivalue, false, 2, lang);
                }
                else {
                    svalue = (0, fmoney_1.fmoney)(ivalue, false, this.$schema.precision, lang);
                }
                break;
            case 'integer':
                svalue = (0, fnumber_1.fnumber)(ivalue, 0, lang);
                break;
        }
        // console.log($schema.type + 'Computed(get)', propName, JSON.stringify(svalue), err);
        return svalue;
    }
    /**
     * ustawienie wartości na modelu
     *
     * @protected
     * @param {*} newValue
     * @returns
     * @memberof WrappedPropertyNumber
     */
    setValue(newValue) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (this.$disabled) {
            return;
        }
        // var lang = this._options._lang ?? this._options.schemaMethods.lang;
        const lang = (_b = (_a = this._options._lang) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : lang_1.defaultLang.current;
        this._internal.typeok = true;
        let ivalue = null;
        if (this._options.dirtyOnInput) {
            this.$dirty = true;
        }
        this._options._userInput = true;
        if (this._options.lazyNumbers && this.$hasFocus) {
            // this.$setUserData('lazyValue', newValue);
            this.lazyValue = newValue;
        }
        // console.log('set model', JSON.stringify(newValue));
        if (newValue === '' || newValue == null) {
            /*
            if (this.$dirty && this.$schema.fieldRequired) {
              this.$error = getRuleMessage(this._internal.schema, 'required', newValue, this.$schema);
              // ok = false;
              // typeok = false;
            }
            */
            /*
                                      if (schema.default !== undefined) {
                                          ivalue = schema.default;
                                          //if (ivalue===0) {
                                          //    typeok=true;
                                          //}
                                      }
                                      */
            ivalue = null;
            // this.$setUserData('stringValue', null);
        }
        else {
            ivalue = +newValue.replace(/\s/g, '').replace(lang.decimalSeparator, '.');
            if (ivalue > Number.MAX_SAFE_INTEGER) {
                ivalue = Number.POSITIVE_INFINITY;
            }
            if (ivalue < Number.MIN_SAFE_INTEGER) {
                ivalue = Number.NEGATIVE_INFINITY;
            }
            if (isNaN(ivalue) || !isFinite(ivalue)) {
                /*
                if (this.$dirty) {
                  this.$error = getRuleMessage(this._internal.schema, 'type', newValue, this.$schema);
                }
                this._internal.typeok = false;
                */
                this._internal.typeok = false;
                // this.$setUserData('stringValue', newValue);
                // this.stringValue = newValue;
                // ivalue = schema.default || null;
                ivalue = null;
            }
            else {
                // this.$setUserData('stringValue', null);
            }
        }
        // savedValue = ivalue;
        // if (this.focused) {
        if (!this._internal.typeok) {
            // tslint:disable-next-line: no-console
            // console.log('set $stringValue', newValue);
            if ((_c = this._options._anyEvent) === null || _c === void 0 ? void 0 : _c.invalidValue) {
                const prevValue = this.$stringValue;
                this.$setUserData('$stringValue', newValue);
                if (prevValue !== newValue) {
                    (0, functions_1.runEvent)({ type: 'invalidValue', target: this, value: newValue, prevValue });
                }
            }
            else {
                this.$setUserData('$stringValue', newValue);
            }
            // this._internal.vm.stringValue = newValue;
        }
        else {
            if ((_d = this._options._anyEvent) === null || _d === void 0 ? void 0 : _d.invalidValue) {
                const prevValue = this.$stringValue;
                this.$setUserData('$stringValue', null);
                if (prevValue !== null) {
                    (0, functions_1.runEvent)({ type: 'invalidValue', target: this, value: null, prevValue });
                }
            }
            else {
                this.$setUserData('$stringValue', null);
            }
            // this._internal.vm.stringValue = null;
        }
        let dvalue = 0;
        let wasBefore = false;
        if (ivalue === null && ((_e = this._options._anyEvent) === null || _e === void 0 ? void 0 : _e.beforeChange)) {
            const prevValue = this.$model;
            const event = { type: 'beforeChange', target: this, value: ivalue, prevValue };
            if ((0, functions_1.runEvent)(event)) {
                wasBefore = true;
                ivalue = event.value;
            }
        }
        if (ivalue === null) {
            if ((_f = this._options._anyEvent) === null || _f === void 0 ? void 0 : _f.change) {
                const prevValue = this.$model;
                this.$model = null;
                if (prevValue !== null) {
                    (0, functions_1.runEvent)({ type: 'change', target: this, value: null, prevValue });
                }
            }
            else {
                this.$model = null;
            }
        }
        else {
            switch (this.$schema.type) {
                case 'integer':
                    // console.log('set model', obj.$path, JSON.stringify(ivalue), JSON.stringify(mround(ivalue, 0)));
                    dvalue = (0, mround_1.mround)(ivalue, 0);
                    break;
                case 'money':
                    if (this.$schema.precision === undefined) {
                        dvalue = (0, mround_1.mround)(ivalue, 2);
                    }
                    else {
                        dvalue = (0, mround_1.mround)(ivalue, this.$schema.precision);
                    }
                    break;
                case 'number':
                    if (this.$schema.precision === undefined) {
                        dvalue = (0, mround_1.mround)(ivalue, 8);
                    }
                    else {
                        dvalue = (0, mround_1.mround)(ivalue, this.$schema.precision);
                    }
                    break;
            }
            if (!wasBefore && ((_g = this._options._anyEvent) === null || _g === void 0 ? void 0 : _g.beforeChange)) {
                const prevValue = this.$model;
                if (dvalue != prevValue) {
                    const event = { type: 'beforeChange', target: this, value: dvalue, prevValue };
                    if ((0, functions_1.runEvent)(event)) {
                        dvalue = event.value;
                    }
                }
            }
            // console.log(schema.type + 'Computed(set)', propName, JSON.stringify(dvalue), JSON.stringify(typeok));
            // parent[propName] = dvalue;
            if ((_h = this._options._anyEvent) === null || _h === void 0 ? void 0 : _h.change) {
                const prevValue = this.$model;
                this.$model = dvalue;
                if (dvalue != prevValue) {
                    (0, functions_1.runEvent)({ type: 'change', target: this, value: dvalue, prevValue });
                }
            }
            else {
                this.$model = dvalue;
            }
            // runEvent({ type: 'change', target: this, value: newValue, prevValue })
            // this.$model = dvalue;
        }
    }
    get $hasFocus() {
        return super.$hasFocus;
        // return this._internal.reactiveData.focused;
    }
    /**
     * czy pole ma fokus
     *
     * @memberof WrappedPropertyBase
     */
    set $hasFocus(newValue) {
        if (newValue) {
            if (this._options.lazyNumbers) {
                const v = this.getValue();
                this.lazyValue = v;
                // this.$setUserData('lazyValue', v);
                // console.log('setString on focus', v);
            }
            super.$hasFocus = true;
        }
        else {
            if (this._options.lazyNumbers) {
                // var prevValue = this.$getUserData('lazyValue', null);
                // console.log('setStringValue', null);
                // this.$setUserData('stringValue', null);
                // console.log('setFocus', false);
                this.lazyValue = undefined;
                super.$hasFocus = false;
                // this.setValue(prevValue);
            }
            else {
                super.$hasFocus = false;
            }
        }
    }
    $getInvalidValues(res = []) {
        if (!this._internal.typeok) {
            const svalue = this.$getUserData('$stringValue');
            if (svalue) {
                res.push({
                    $path: this.$path,
                    $value: svalue
                });
            }
        }
        return res;
    }
}
exports.WrappedPropertyNumber = WrappedPropertyNumber;
WrappedPropertyCtor_1.WrappedPropertyCtor.integer = WrappedPropertyNumber;
WrappedPropertyCtor_1.WrappedPropertyCtor.number = WrappedPropertyNumber;
WrappedPropertyCtor_1.WrappedPropertyCtor.money = WrappedPropertyNumber;
exports.default = WrappedPropertyNumber;
//# sourceMappingURL=WrappedPropertyNumber.js.map